/* Atsiliepimų modulis. Duomenys: assets/muzikinis-reviews.json
   Reitingų šaltinyje NĖRA, todėl žvaigždučių, vidurkio ir filtravimo pagal
   žvaigždutes čia nėra sąmoningai. Tekstai — redakciniai vertimai, tai pažymėta
   kiekvienoje kortelėje. */
(function () {
  'use strict';

  /* V43 §16 — handle → rodomas pavadinimas. Vienintelė vieta. */
  var PRODUCT_NAMES = {
    'muzikinis-zaidimas': 'MUZIKINIS ŽAIDIMAS - PIRMA DALIS',
    'muzikinis-zaidimas-x-agata': 'MUZIKINIS ŽAIDIMAS - AGATA',
    'muzikinis-zaidimas-x-kernagis': 'MUZIKINIS ŽAIDIMAS - KERNAGIS',
    'po-dutukstantuju': 'PO DUTŪKSTANTŲJŲ',
    'paklausom-is-naujo': 'PAKLAUSOM IŠ NAUJO',
    'baltos-kaledos': 'BALTOS KALĖDOS',
    'musu-dienos-kaip-svente': 'MŪSŲ DIENOS, KAIP ŠVENTĖ'
  };
  var CACHE = null, LOADING = null;

  function load(url) {
    if (CACHE) return Promise.resolve(CACHE);
    if (LOADING) return LOADING;
    LOADING = fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        if (!d || !Array.isArray(d.reviews)) throw new Error('Netinkama struktūra');
        CACHE = d; return d;
      });
    return LOADING;
  }


  function loadPlayerReviews(api) {
    if (!api) return Promise.resolve([]);
    api = String(api).replace(/\/+$/, '');
    return fetch(api + '/reviews?limit=200&offset=0&sort=new')
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { return d && Array.isArray(d.reviews) ? d.reviews : []; })
      .catch(function () { return []; });
  }


  /* V49 §15 — lietuviškos datos.
     Šaltinis (Google eksportas) datas pateikia angliškai: „4 months ago",
     „a year ago", „Edited 8 months ago". Rodyti jas taip vartotojui negalima.
     Tikslių datų šaltinyje nėra, todėl verčiame santykinę formą 1:1,
     nieko neišgalvodami. */
  var LT_MONTHS = ['mėnesio', 'mėnesių', 'mėnesių'];

  function ltPlural(n, forms) {
    var mod10 = n % 10, mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return forms[0];
    if (mod10 >= 2 && (mod100 < 10 || mod100 >= 20)) return forms[1];
    return forms[2];
  }

  function ltDate(raw) {
    if (!raw) return '';
    var src = String(raw).trim();
    var iso = src.match(/^(\d{4}-\d{2}-\d{2})T/);
    if (iso) return iso[1];
    if (/^\d{4}-\d{2}-\d{2}$/.test(src)) return src;
    var edited = /^edited\s+/i.test(src);
    var body = src.replace(/^edited\s+/i, '');
    var out = null;

    var m = body.match(/^(a|an|\d+)\s+(minute|hour|day|week|month|year)s?\s+ago$/i);
    if (m) {
      var n = /^(a|an)$/i.test(m[1]) ? 1 : parseInt(m[1], 10);
      var unit = m[2].toLowerCase();
      if (unit === 'minute') out = 'prieš ' + n + ' ' + ltPlural(n, ['minutę', 'minutes', 'minučių']);
      else if (unit === 'hour') out = 'prieš ' + n + ' ' + ltPlural(n, ['valandą', 'valandas', 'valandų']);
      else if (unit === 'day') out = 'prieš ' + n + ' ' + ltPlural(n, ['dieną', 'dienas', 'dienų']);
      else if (unit === 'week') out = 'prieš ' + n + ' ' + ltPlural(n, ['savaitę', 'savaites', 'savaičių']);
      else if (unit === 'month') out = 'prieš ' + n + ' ' + ltPlural(n, ['mėnesį', 'mėnesius', 'mėnesių']);
      else if (unit === 'year') out = n === 1 ? 'prieš metus'
        : 'prieš ' + n + ' ' + ltPlural(n, ['metus', 'metus', 'metų']);
    }

    if (!out) return src;                    /* neatpažinta – rodome originalą */
    return edited ? 'redaguota ' + out : out;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function track(name, payload) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: name }, payload));
    }
  }

  function Reviews(root) {
    /* V73 · PERF-001 — IDEMPOTENT INIT.
       `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Be šios apsaugos tas pats elementas
       theme editoriuje inicializuojamas kartotinai: dubliuojasi
       listeneriai, o kai kur ir tinklo užklausos. Vienas elementas —
       viena inicializacija. */
    if (root.dataset.mzrevReady === '1') return;
    root.dataset.mzrevReady = '1';

    var url = root.dataset.reviewsUrl;
    var playerApi = root.dataset.playerReviewsApi || 'https://mz-live-map.justas-3c0.workers.dev';
    var scope = root.dataset.reviewsScope || 'all';
    var handle = root.dataset.reviewsHandle || '';
    var ctx = (root.dataset.reviewsContext || '').split(',')
      .map(function (c) { return c.trim(); }).filter(Boolean);
    var step = parseInt(root.dataset.reviewsStep, 10) || 8;
    /* V74 · REVIEWS-001 — MOBILE PRADINIS KIEKIS 4 -> 3.

       Išmatuota gyvai (390 px): viena kortelė 448-502 px, todėl keturios
       kortelės užima 2263 px, o visa skiltis — 3338 px = 3,7 viewport'o.
       Desktop tuo metu buvo 2,8 viewport'o.

       Komentaras virš šios eilutės nuo V40 teigė „ne daugiau kaip trys",
       bet kodas ribojo iki keturių — tekstas ir logika nesutapo.
       Dabar suvienodinta ties trimis.

       Šrifto NEMAŽINU — task'o prioritetas yra trumpesnis vertikalus
       footprint, ne smulkesnis tekstas. „Rodyti daugiau" veikia toliau,
       todėl visi atsiliepimai pasiekiami. */
    var isRail = !!root.querySelector('[data-rail-track][data-reviews-list]');
    if (!isRail && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      step = Math.min(step, 3);
    }

    /* V117 §7 — BĖGELYJE MOBILE RIBOJIMAS NETAIKOMAS.

       Rasta QA gyvai (390 px): bėgelis turėjo 3 korteles, todėl pirma
       eilė buvo 604 px, antra — 390 px, t. y. nejudanti. „RODYTI DAR"
       bėgelio režime paslėptas, tad daugiau atsiliepimų nebuvo kaip
       pasiekti. Priežastis — v74 mobile riba `step <= 3`, kuri buvo
       skirta VERTIKALIAM tinkleliui, kur kiekviena kortelė kainuoja
       ~450 px puslapio aukščio.

       Bėgelyje kortelės kainuoja NULĮ vertikalaus aukščio, o gausa yra
       visas sekcijos tikslas. Todėl čia rodomas visas homepage pool. */
    if (isRail) step = 30;
    /* V117 §7 — bėgelio režime yra DVI eilės, todėl taikinių gali būti
       daugiau nei vienas. Kortelės dalinamos pakaitomis, kad abi eilės
       prisipildytų tolygiai ir nebūtų pusiau tuščios antros eilės.
       `list` paliekamas kaip pirmasis taikinys — visa likusi logika
       (filtrai, tuščia būsena) jo ir tikisi. */
    var lists = [].slice.call(root.querySelectorAll('[data-reviews-list]'));
    var list = lists[0];
    var more = root.querySelector('[data-reviews-more]');
    var counter = root.querySelector('[data-reviews-count-out]');
    var fail = root.querySelector('[data-reviews-fail]');
    if (!url || !list) return;

    var items = [], shown = 0;

    /* ------------------------------------------------------------------
       V111 · DUOMENŲ NORMALIZAVIMAS

       `MUZIKINIS_ATSILIEPIMAI_MASTER_v2` turi kitokius laukus nei senasis
       rinkinys: `ts` vietoj `d`, pridėtas `rt` (rodymo rating), nebėra
       `c` (kontekstų) ir `r` (savininko atsakymo).

       Be šio sluoksnio kortelės būtų lūžusios — `r.c` ir `r.d` grąžintų
       `undefined`. Normalizuojame vieną kartą, kad likusi logika
       (filtrai, rail, dokrovimas) veiktų nepakeista.
       ------------------------------------------------------------------ */
    function normalize(r) {
      if (!r.c) r.c = [];
      if (!r.d && r.ts) r.d = r.ts;

      /* V135 — senasis Google reviews JSON saugo produkto pavadinimą,
         o PDP filtravimas naudoja Shopify handle. Normalizuojame čia,
         kad konkretus PDP nepaslėptų visų senųjų atsiliepimų. */
      var legacyHandles = {
        'MUZIKINIS ŽAIDIMAS - PIRMA DALIS': 'muzikinis-zaidimas',
        'MUZIKINIS ŽAIDIMAS (Originalas)': 'muzikinis-zaidimas',
        'MUZIKINIS ŽAIDIMAS - AGATA': 'muzikinis-zaidimas-x-agata',
        'MUZIKINIS ŽAIDIMAS - KERNAGIS': 'muzikinis-zaidimas-x-kernagis',
        'BALTOS KALĖDOS': 'baltos-kaledos',
        'PO DUTŪKSTANTŲJŲ': 'po-dutukstantuju',
        'PAKLAUSOM IŠ NAUJO': 'paklausom-is-naujo',
        'MŪSŲ DIENOS, KAIP ŠVENTĖ': 'musu-dienos-kaip-svente'
      };
      if (r.h && legacyHandles[r.h]) r.h = legacyHandles[r.h];
      return r;
    }

    function stars(n) {
      if (typeof n !== 'number' || n < 1) return '';
      /* Provenance: balas REDAKCINIS, ne Google patvirtintas. Todėl
         `aria-label` sako tik „įvertinimas", be Google paminėjimo. */
      var full = '', i;
      for (i = 1; i <= 5; i++) full += '<span class="rstar' + (i <= n ? ' is-on' : '') + '" aria-hidden="true">★</span>';
      return '<p class="rcard__stars" role="img" aria-label="'
        + esc((root.dataset.reviewsRatingLabel || 'Įvertinimas') + ' ' + n + '/5') + '">'
        + full + '</p>';
    }

    function card(r) {
      var el = document.createElement('article');
      el.className = 'rcard';
      var sourceLabel = r.web ? 'Pateikta Muzikiniszaidimas.lt' : (root.dataset.reviewsBadge || 'Google atsiliepimas');
      var link = r.u
        ? '<a class="rcard__src" href="' + esc(r.u) + '" target="_blank" rel="noopener noreferrer">'
          + esc(sourceLabel) + '</a>'
        : '<span class="rcard__src">' + esc(sourceLabel) + '</span>';

      var st = stars(r.rt);
      var long = (r.t || '').length > 220;
      var body = long
        ? '<p class="rcard__text" data-clamp>' + esc(r.t) + '</p>'
          + '<button type="button" class="rcard__toggle" data-reviews-toggle>'
          + esc(root.dataset.reviewsMoreLabel || 'Rodyti daugiau') + '</button>'
        : '<p class="rcard__text">' + esc(r.t) + '</p>';

      var reply = r.r
        ? '<div class="rcard__reply"><b>' + esc(root.dataset.reviewsReply || 'Mūsų atsakymas') + '</b><p>'
          + esc(r.r) + '</p></div>'
        : '';

      /* V43 §16: prie kiekvieno atsiliepimo rodoma, ką žmogus žaidė.
         Mapping laikomas VIENOJE vietoje (PRODUCT_NAMES viršuje). */
      var played = r.h && PRODUCT_NAMES[r.h]
        ? '<p class="rcard__played"><span>' + esc(root.dataset.reviewsPlayed || 'Žaidė:') + '</span> '
          + esc(PRODUCT_NAMES[r.h]) + '</p>'
        : '';

      /* Ilga redakcinio vertimo pastaba iš kiekvienos kortelės pašalinta —
         ji kartojosi 16 kartų. Vienintelė skaidrumo eilutė yra sekcijos apačioje. */
      el.innerHTML =
        st +
        played +
        body +
        '<p class="rcard__meta"><b>' + esc(r.a) + '</b><span>' + esc(ltDate(r.d)) + '</span></p>' +
        reply +
        link;
      return el;
    }

    function render(reset) {
      if (reset) { lists.forEach(function (l) { l.innerHTML = ''; l.removeAttribute('aria-busy'); }); shown = 0; }
      var slice = items.slice(shown, shown + step);
      var frags = lists.map(function () { return document.createDocumentFragment(); });
      slice.forEach(function (r, i) { frags[i % lists.length].appendChild(card(r)); });
      lists.forEach(function (l, i) { l.appendChild(frags[i]); });

      /* V119 — BEGALINIS CIKLAS BE SIŪLĖS.
         Bėgelis, kuris pasiekęs galą peršoka į pradžią, atrodo sugedęs.
         Todėl kortelių rinkinys PADVIGUBINAMAS, o `rail.js` ciklo režime
         grįžta į nulį ties puse — vizualiai tai ta pati vieta, todėl
         šuolio nesimato.
         Klonai turi `aria-hidden`, kad ekrano skaitytuvas kiekvieno
         atsiliepimo neperskaitytų dukart. */
      var railMoves = isRail && [].some.call(root.querySelectorAll('[data-rail]'), function (r) { return (parseInt(r.dataset.railDrift, 10) || 0) > 0; });
      if (railMoves) {
        lists.forEach(function (l) {
          [].slice.call(l.children).forEach(function (n) {
            if (n.dataset.railClone === '1') n.remove();
          });
          var originals = [].slice.call(l.children);
          var dup = document.createDocumentFragment();
          originals.forEach(function (n) {
            var c = n.cloneNode(true);
            c.dataset.railClone = '1';
            c.setAttribute('aria-hidden', 'true');
            dup.appendChild(c);
          });
          l.appendChild(dup);
        });
      }
      shown += slice.length;
      if (more) more.hidden = shown >= items.length;
      if (counter) {
        counter.textContent = (root.dataset.reviewsCounterTpl || 'Rodoma {{ x }} iš {{ y }}')
          .replace('{{ x }}', shown).replace('{{ y }}', items.length);
        counter.hidden = false;
      }
    }

    Promise.all([load(url), loadPlayerReviews(playerApi)]).then(function (all) {
      var data = all[0];
      var player = all[1] || [];
      var liveItems = player.map(function (r, idx) {
        return normalize({
          id: r.id || ('WEB-' + idx), o: -100000 + idx, a: r.author || 'Žaidėjas',
          t: r.body || '', ts: r.created_at || new Date().toISOString(), d: r.created_at || '',
          h: r.product || '', u: '', rt: Number(r.rating) || null, rs: 'Pateikta Muzikiniszaidimas.lt',
          c: [], hp: true, f: true, fp: true, web: true
        });
      }).filter(function (r) {
        /* V138: savininko 2026-09-22 bandomasis Kernagio įrašas nerodomas. */
        return r.t && !(String(r.a).trim().toLowerCase() === 'justas' &&
          String(r.t).trim().toLowerCase() === 'testas testas' &&
          r.h === 'muzikinis-zaidimas-x-kernagis' &&
          String(r.d).slice(0, 10) === '2026-09-22');
      });
      /* V136 — atsiliepimų SKAIČIUS čia nebeskaičiuojamas. Anksčiau jis buvo
         ranka įrašytas Liquid skaičius + žmonių suvesti, todėl rodė 72 vietoj 113.
         Visus skaičius svetainėje dabar skaičiuoja vienas šaltinis —
         assets/product-rating.js ([data-rc], [data-rating-for]). */
      items = liveItems.concat(data.reviews.map(normalize).filter(function (r) { return r.t; }));

      /* Homepage naudoja atrinktą pool'ą (MASTER §5: `Homepage_pool = TAIP`,
         40 geriausių). Kitur rodomi visi, kurie turi tekstą. */
      if (root.dataset.reviewsPool === 'homepage') {
        var pool = items.filter(function (r) { return r.hp; });
        if (pool.length >= 12) items = pool;
      }
      if (scope === 'product' && handle) {
        items = items.filter(function (r) { return r.h === handle; });
      }
      /* 44.2: kontekstinis atrinkimas. Jei pagal kontekstą nieko nelieka,
         grįžtame prie viso rinkinio, kad blokas nebūtų tuščias. */
      if (ctx.length) {
        var byCtx = items.filter(function (r) {
          return (r.c || []).some(function (c) { return ctx.indexOf(c) !== -1; });
        });
        if (byCtx.length >= 3) items = byCtx;
      }
      // Pradžioje featured, po jų — šaltinio eiliškumu (tikslių datų nėra)
      items.sort(function (a, b) {
        var fa = scope === 'product' ? a.fp : a.f;
        var fb = scope === 'product' ? b.fp : b.f;
        if (fa !== fb) return fa ? -1 : 1;
        return a.o - b.o;
      });
      if (!items.length) { root.hidden = true; return; }

      /* ---------------------------------------------------------------
         V91 · R02 — DATA-DRIVEN FILTRAI

         `items` po šio taško lieka BAZINIS rinkinys, o rodomas
         `view`. Taip filtrų nuėmimas grąžina viską be pakartotinio
         tinklo kvietimo.

         Kiekvienas filtras pasirodo TIK jei duomenyse yra ką filtruoti.
         Įvertinimo filtras rodomas tik kai `ratings_available` = true —
         šiandien balų nėra, todėl vartotojas jo nemato. Suvedus tikrus
         įvertinimus jis įsijungia pats.
         --------------------------------------------------------------- */
      var base = items.slice();
      var fWrap = root.querySelector('[data-reviews-filters]');

      if (fWrap) {
        var sel = function (n) { return root.querySelector('[data-rev-filter="' + n + '"]'); };
        var selProduct = sel('product');
        var selRating = sel('rating'), selSort = sel('sort');
        var resetBtn = root.querySelector('[data-rev-reset]');
        var ratingWrap = root.querySelector('[data-rev-rating-wrap]');
        var approxNote = root.querySelector('[data-rev-approx]');

        /* Produkto parinktys — iš REALIŲ duomenų, ne iš rankinio sąrašo.
           Pridėjus naują produktą su atsiliepimais jis atsiranda pats. */
        if (selProduct) {
          var names = {};
          try { names = JSON.parse(root.dataset.reviewsNames || '{}'); } catch (err) {}
          var counts = {};
          base.forEach(function (r) { if (r.h) counts[r.h] = (counts[r.h] || 0) + 1; });
          var handles = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
          selProduct.innerHTML = '<option value="all">'
            + (root.dataset.reviewsAllProducts || 'Visi produktai') + '</option>'
            + handles.map(function (h) {
                return '<option value="' + h + '">' + (names[h] || h) + ' (' + counts[h] + ')</option>';
              }).join('');
          /* Vienas produktas — filtras beprasmis. */
          if (handles.length < 2) selProduct.closest('.rfilters__f').hidden = true;
          var qp = new URLSearchParams(window.location.search).get('product');
          if (qp && counts[qp]) selProduct.value = qp;
        }

        var hasRatings = base.some(function (r) { return typeof r.rt === 'number' && r.rt >= 1; });
        if (ratingWrap) ratingWrap.hidden = !hasRatings;
        if (approxNote && data.dates_approx) approxNote.hidden = false;

        var monthsAgo = function (iso) {
          if (!iso) return null;
          var t = Date.parse(iso);
          if (isNaN(t)) return null;
          return (Date.now() - t) / (1000 * 60 * 60 * 24 * 30.4);
        };

        var apply = function () {
          var p = selProduct ? selProduct.value : 'all';
          var rat = (selRating && hasRatings) ? selRating.value : 'all';
          var srt = selSort ? selSort.value : 'new';

          var view = base.filter(function (r) {
            if (p !== 'all' && r.h !== p) return false;
            if (rat !== 'all' && String(r.rt) !== rat) return false;
            return true;
          });

          view.sort(function (a, b) {
            if (srt === 'best' || srt === 'worst') {
              var ra = Number(a.rt) || 0, rb = Number(b.rt) || 0;
              if (ra !== rb) return srt === 'best' ? rb - ra : ra - rb;
            }
            var ta = Date.parse(a.ts || '') || 0, tb = Date.parse(b.ts || '') || 0;
            if (ta !== tb) return srt === 'old' ? ta - tb : tb - ta;
            return a.o - b.o;
          });

          items = view;
          if (resetBtn) {
            resetBtn.hidden = (p === 'all' && rat === 'all' && srt === 'new');
          }
          var empty = root.querySelector('[data-rev-empty]');
          if (empty) empty.hidden = view.length !== 0;
          render(true);
        };

        [selProduct, selRating, selSort].forEach(function (el) {
          if (el) el.addEventListener('change', apply);
        });
        if (resetBtn) {
          resetBtn.addEventListener('click', function () {
            if (selProduct) selProduct.value = 'all';
            if (selRating) selRating.value = 'all';
            if (selSort) selSort.value = 'new';
            apply();
          });
        }
        fWrap.hidden = false;
        apply();
        return;
      }

      render(true);
    }).catch(function (e) {
      // Klaidos atveju rodome trumpą žinutę, ne sugriuvusį bloką
      if (fail) fail.hidden = false;
      if (more) more.hidden = true;
      /* V136 — nepavykus, skeletonas neturi mirgėti amžinai */
      lists.forEach(function (l) {
        l.querySelectorAll('.rcard--sk').forEach(function (n) { n.remove(); });
        l.removeAttribute('aria-busy');
      });
      if (window.console) console.warn('Atsiliepimai:', e);
    });

    if (more) {
      more.addEventListener('click', function () {
        render(false);
        track('reviews_load_more', { page_scope: scope, product_handle: handle, visible_count: shown, total_count: items.length });
      });
    }

    list.addEventListener('click', function (e) {
      var t = e.target.closest('[data-reviews-toggle]');
      if (t) {
        var p = t.previousElementSibling;
        var open = p.classList.toggle('is-open');
        t.textContent = open
          ? (root.dataset.reviewsLessLabel || 'Rodyti mažiau')
          : (root.dataset.reviewsMoreLabel || 'Rodyti daugiau');
        return;
      }
      var src = e.target.closest('.rcard__src');
      if (src) track('reviews_source_click', { page_scope: scope, product_handle: handle });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-reviews-root]').forEach(function (n) {
      if (n._mzReviews) return;
      n._mzReviews = true;
      Reviews(n);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();
